module.exports = __webpack_public_path__ + "img/selectedfolder.2a268b90.svg";